/* =============================================================
   Luxe Sateen Bamboo — Guided Bundle Builder (3-step)
   1) Choose bundle  2) Customize sets (all at once)  3) Gifts & review
   Adds sheets + free gifts + paid add-ons to the cart and opens the
   existing sidecart (which resolves the mix & match bundle discount
   and the /checkout?discount= URL).
   ============================================================= */
(function () {
  "use strict";

  var root = document.querySelector("[data-bbx]");
  if (!root) return;
  var cfgEl = root.querySelector("[data-bbx-config]");
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var SIZE_IDX = CFG.sizeIdx;
  var COLOR_IDX = CFG.colorIdx;
  var MONEY = function (c) { return "$" + (Math.round(c) / 100).toFixed(2).replace(/\.00$/, ""); };
  var MONEY2 = function (c) { return "$" + (Math.round(c) / 100).toFixed(2); };
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* ---------- swatch fill ---------- */
  var SW_MAP = {
    white: "white", ivory: "white", linen: "white",
    cream: "cream", sand: "cream", dune: "dune", tan: "dune", camel: "dune",
    silver: "silver", graphite: "silver", charcoal: "navy", stone: "silver", mist: "silver",
    shore: "shore", sky: "shore", blue: "shore",
    sage: "sage", green: "sage",
    navy: "navy"
  };
  function handleize(s) { return String(s || "").toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, ""); }
  function swatchAttrs(colorName, img) {
    if (img) return { cls: "", style: "background-image:url(" + img + ")" };
    var h = handleize(colorName);
    var key = SW_MAP[h] || (SW_MAP[h.split("-")[0]] || "default");
    return { cls: "bbx-sw-" + key, style: "" };
  }
  function swatchHTML(colorName, img, extraCls) {
    var sw = swatchAttrs(colorName, img);
    return '<span class="bbx-swatch ' + (extraCls || "") + " " + sw.cls + '"' + (sw.style ? ' style="' + sw.style + '"' : "") + "></span>";
  }

  /* ---------- bundle tier resolution (mirrors bamboo-landing) ---------- */
  function stripBundlePayload(tag) { var m = String(tag || "").match(/^bundle:default:(.+)$/i); return m ? m[1].trim() : ""; }
  var TIER_ONLY = /^\d+-\d+(\|\d+-\d+)*$/;
  function parsePayload(pl) {
    var p = String(pl || "").trim();
    if (!p) return null;
    if (TIER_ONLY.test(p)) return { key: null, tiers: p };
    var m = p.match(/^(.+?):(\d+-\d+(\|\d+-\d+)*)$/);
    return m ? { key: m[1].trim(), tiers: m[2] } : null;
  }
  function longestSkuKey(sku, keys) {
    var s = String(sku || "").trim().toUpperCase();
    if (!s) return null;
    var uniq = [];
    keys.forEach(function (k) { if (k && uniq.indexOf(k) < 0) uniq.push(k); });
    uniq.sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < uniq.length; i++) { if (s.indexOf(uniq[i].toUpperCase()) === 0) return uniq[i]; }
    return null;
  }
  var _tierCache = {};
  function tiersForSku(sku) {
    var ck = sku || "_";
    if (_tierCache[ck]) return _tierCache[ck];
    var entries = [];
    (CFG.tags || []).forEach(function (tag) {
      var parsed = parsePayload(stripBundlePayload(tag));
      if (parsed && parsed.tiers) entries.push(parsed);
    });
    var hasScoped = entries.some(function (e) { return !!e.key; });
    var matchKey = null;
    if (hasScoped) matchKey = longestSkuKey(sku, entries.filter(function (e) { return e.key; }).map(function (e) { return e.key; }));
    var byQty = {};
    entries.forEach(function (parsed) {
      if (hasScoped) {
        if (!parsed.key) return;
        if (!matchKey || String(parsed.key).toUpperCase() !== String(matchKey).toUpperCase()) return;
      } else if (parsed.key) { return; }
      parsed.tiers.split("|").forEach(function (seg) {
        var dash = seg.lastIndexOf("-");
        if (dash <= 0) return;
        var qty = parseInt(seg.slice(0, dash), 10);
        var price = parseFloat(seg.slice(dash + 1));
        if (isNaN(qty) || isNaN(price)) return;
        var cents = Math.round(price * 100);
        if (!byQty[qty] || cents < byQty[qty]) byQty[qty] = cents;
      });
    });
    var out = Object.keys(byQty).map(function (q) { return { units: parseInt(q, 10), price: byQty[q] }; }).sort(function (a, b) { return a.units - b.units; });
    _tierCache[ck] = out;
    return out;
  }

  /* ---------- variant model ---------- */
  var VARIANTS = CFG.variants || [];
  function optAt(v, idx) { return idx >= 0 && v.options ? v.options[idx] : ""; }
  function sizeOf(v) { return SIZE_IDX >= 0 ? optAt(v, SIZE_IDX) : ""; }
  function colorOf(v) { return COLOR_IDX >= 0 ? optAt(v, COLOR_IDX) : ""; }

  var SIZES = [];
  VARIANTS.forEach(function (v) { var s = sizeOf(v); if (s && SIZES.indexOf(s) < 0) SIZES.push(s); });
  if (!SIZES.length) SIZES = [""];

  function variantsForSize(size) { return VARIANTS.filter(function (v) { return sizeOf(v) === size; }); }
  function colorsForSize(size) {
    var seen = {}, out = [];
    variantsForSize(size).forEach(function (v) {
      var c = colorOf(v), key = c || "_";
      if (seen[key]) return;
      seen[key] = true;
      out.push({ color: c, variant: v });
    });
    return out;
  }
  function sizeAvailable(size) { return variantsForSize(size).some(function (v) { return v.available; }); }
  function findVariant(size, color) {
    return VARIANTS.filter(function (v) { return sizeOf(v) === size && (COLOR_IDX < 0 || colorOf(v) === color); })[0] || null;
  }
  function salePctForSize(size, price) {
    var max = 0;
    variantsForSize(size).forEach(function (v) { if (v.available && v.price > max) max = v.price; });
    if (max > 0 && price < max) return Math.round(((max - price) / max) * 100);
    return 0;
  }
  function firstAvailable() { return VARIANTS.filter(function (v) { return v.available; })[0] || VARIANTS[0]; }
  var REP = firstAvailable();

  /* ---------- mix & match pricing (mirrors sidecart greedy chunking) ---------- */
  function priceSets(sets) {
    var list = 0;
    sets.forEach(function (s) { list += s.price; });
    var units = sets.map(function (s) { return { price: s.price, tiers: tiersForSku(s.sku) }; }).sort(function (a, b) { return b.price - a.price; });
    var tierUnitOpts = [];
    units.forEach(function (u) { u.tiers.forEach(function (t) { if (t.units > 1 && tierUnitOpts.indexOf(t.units) < 0) tierUnitOpts.push(t.units); }); });
    tierUnitOpts.sort(function (a, b) { return b - a; });
    var discount = 0, pool = units.slice();
    while (pool.length) {
      var applied = false;
      for (var oi = 0; oi < tierUnitOpts.length; oi++) {
        var u = tierUnitOpts[oi];
        if (u > pool.length) continue;
        var chunk = pool.slice(0, u), bundlePrice = 0;
        chunk.forEach(function (c) { c.tiers.forEach(function (t) { if (t.units === u && t.price > bundlePrice) bundlePrice = t.price; }); });
        if (bundlePrice <= 0) continue;
        var actual = chunk.reduce(function (s, c) { return s + c.price; }, 0);
        var d = Math.max(0, actual - bundlePrice);
        if (d <= 0) continue;
        discount += d;
        pool = pool.slice(u);
        applied = true;
        break;
      }
      if (!applied) break;
    }
    return { list: list, discount: discount, total: list - discount };
  }
  // Total range across sizes for a tier of N identical sets: {min,max,minWas}.
  function tierRange(units) {
    var totals = [];
    SIZES.forEach(function (size) {
      var v = colorsForSize(size).filter(function (c) { return c.variant.available; })[0];
      if (!v) return;
      var t = tiersForSku(v.variant.sku).filter(function (x) { return x.units === units; })[0];
      var total = t ? t.price : v.variant.price * units;
      var was = (v.variant.compareAt > v.variant.price ? v.variant.compareAt : v.variant.price) * units;
      totals.push({ total: total, was: was });
    });
    if (!totals.length) return null;
    totals.sort(function (a, b) { return a.total - b.total; });
    return { min: totals[0].total, max: totals[totals.length - 1].total, minWas: totals[0].was };
  }

  /* ---------- pillow (free gift + paid extras) model ---------- */
  var PILLOW = CFG.pillow || { variants: [] };
  function pillowSizes() { var out = []; (PILLOW.variants || []).forEach(function (v) { if (v.option1 && out.indexOf(v.option1) < 0) out.push(v.option1); }); return out; }
  function pillowColorsForSize(size) {
    var seen = {}, out = [];
    (PILLOW.variants || []).forEach(function (v) {
      if (v.option1 !== size) return;
      var key = v.option2 || "_";
      if (seen[key]) return;
      seen[key] = true;
      out.push({ color: v.option2, variant: v });
    });
    return out;
  }
  function pillowFind(size, color) { return (PILLOW.variants || []).filter(function (v) { return v.option1 === size && (color == null || v.option2 === color); })[0] || null; }

  /* ---------- state ---------- */
  var STATE = {
    selectedUnits: CFG.defaultUnits || 1,
    sets: [],
    pillowGift: null,
    extraPillows: [],   // [{variant, qty}]
    extraMaskQty: 0,
    step: 0
  };
  var STEPS = [
    { key: "bundle", label: "Choose bundle" },
    { key: "customize", label: "Customize sets" },
    { key: "review", label: "Gifts & review" }
  ];

  function defaultSet() {
    var v = REP || VARIANTS[0];
    return { size: sizeOf(v), color: colorOf(v), variantId: v.id, price: v.price, sku: v.sku, img: v.img };
  }
  function setUnits(n) {
    STATE.selectedUnits = n;
    STATE.sets.length = Math.min(STATE.sets.length, n);
    while (STATE.sets.length < n) STATE.sets.push(defaultSet());
    if (n < CFG.pillowGiftMinUnits) STATE.pillowGift = null;
    else ensurePillowGiftDefault();
  }
  function commitSet(i, size, color, variant) {
    STATE.sets[i] = { size: size, color: color, variantId: variant.id, price: variant.price, sku: variant.sku, img: variant.img };
  }
  function ensurePillowGiftDefault() {
    if (STATE.pillowGift || !PILLOW.variants || !PILLOW.variants.length) return;
    var matchColor = (STATE.sets[0] && STATE.sets[0].color) || null;
    var v = (matchColor && pillowFind("Queen", matchColor)) || pillowFind("Queen", null) || PILLOW.variants.filter(function (x) { return x.available; })[0] || PILLOW.variants[0];
    if (v) STATE.pillowGift = { variantId: v.id, size: v.option1, color: v.option2, price: v.price, img: v.img || PILLOW.img };
  }

  /* ---------- dom refs ---------- */
  var elSteps = root.querySelector("[data-bbx-steps]");
  var elProgress = root.querySelector("[data-bbx-progress]");
  var elBack = root.querySelector("[data-bbx-back]");
  var elNext = root.querySelector("[data-bbx-next]");
  var elRailImg = root.querySelector("[data-bbx-rail-img]");
  var elRailBadge = root.querySelector("[data-bbx-rail-badge]");
  var elRailList = root.querySelector("[data-bbx-rail-list]");
  var elRailPrices = root.querySelector("[data-bbx-rail-prices]");
  var elRailWas = root.querySelector("[data-bbx-rail-was]");
  var elRailSaveLine = root.querySelector("[data-bbx-rail-saveline]");
  var elRailSave = root.querySelector("[data-bbx-rail-save]");
  var elRailGiftLine = root.querySelector("[data-bbx-rail-giftline]");
  var elRailGift = root.querySelector("[data-bbx-rail-gift]");
  var elRailNow = root.querySelector("[data-bbx-rail-now]");
  var elRailBody = root.querySelector(".bbx-rail-body");
  var elAddCart = root.querySelector("[data-bbx-addcart]");
  var elAddCartLabel = root.querySelector("[data-bbx-addcart-label]");
  var elCheckout = root.querySelector("[data-bbx-checkout]");

  /* ---------- progress ---------- */
  function renderProgress() {
    elProgress.innerHTML = "";
    STEPS.forEach(function (st, i) {
      var li = document.createElement("li");
      var done = i < STATE.step, active = i === STATE.step;
      li.className = (done ? "is-done " : "") + (active ? "is-active " : "") + "is-clickable";
      li.innerHTML = '<span class="bbx-pnum">' + (done ? "✓" : i + 1) + "</span><span class=\"bbx-plabel\">" + esc(st.label) + "</span>";
      li.addEventListener("click", function () { goTo(i); });
      elProgress.appendChild(li);
    });
  }

  /* ---------- step: bundle ---------- */
  function tierDesc(u) {
    if (u >= 6) return "Upgrade every bedroom.";
    if (u >= 3) return "One for your bed, one for the guest room, one as backup.";
    return "Try a single set, risk-free.";
  }
  function giftValue(o) {
    if (!o) return 0;
    return o.price || o.compareAt || 0;
  }
  function tierGifts(u) {
    var arr = [];
    if (u >= CFG.freeGiftMinUnits && CFG.mask && CFG.mask.available) {
      arr.push({ name: "Bamboo Sateen eye mask", img: CFG.mask.img, value: giftValue(CFG.mask) });
    }
    if (u >= CFG.pillowGiftMinUnits && PILLOW && PILLOW.img != null) {
      arr.push({ name: "Bamboo Pillowcase set", img: PILLOW.img, value: giftValue(PILLOW) });
    }
    return arr;
  }
  function renderBundleStep() {
    var unitsList = [1];
    (tiersForSku(REP ? REP.sku : "")).forEach(function (t) { if (unitsList.indexOf(t.units) < 0) unitsList.push(t.units); });
    unitsList.sort(function (a, b) { return a - b; });
    var maxUnits = unitsList[unitsList.length - 1];

    var html = '<div class="bbx-step">';
    html += '<h2 class="bbx-step-h bbx-serif">Choose your bundle</h2>';
    html += '<p class="bbx-step-note">The more sets you bundle, the lower the per-set price — and you unlock free gifts. Mix colors and sizes freely; the bundle price applies no matter what.</p>';
    html += '<div class="bbx-tiers">';
    unitsList.forEach(function (u) {
      var rng = tierRange(u);
      var now = rng ? rng.min : 0;
      var was = rng ? rng.minWas : 0;
      var per = now / u;
      var isRange = rng && rng.max > rng.min;
      var sel = u === STATE.selectedUnits ? " is-selected" : "";
      var gifts = tierGifts(u);
      html += '<label class="bbx-tier' + sel + '" data-bbx-tier="' + u + '">';
      html += '<span class="bbx-tier-radio"></span>';
      html += '<span class="bbx-tier-main"><span class="bbx-tier-name">' + (u === 1 ? "1 Set" : u + " Sets") + "</span> ";
      html += '<span class="bbx-tier-per">' + MONEY2(per) + "/set" + (isRange ? " · from" : "") + "</span>";
      html += '<div class="bbx-tier-desc">' + esc(tierDesc(u)) + "</div>";
      gifts.forEach(function (g) {
        html += '<div class="bbx-tier-gift"><span class="bbx-tier-gift-ico"' + (g.img ? ' style="background-image:url(\'' + g.img + '\')"' : "") + ' aria-hidden="true"></span>';
        html += '<span class="bbx-tier-gift-txt">FREE ' + esc(g.name) + (g.value ? ' <span class="bbx-tier-gift-val">(' + MONEY(g.value) + " value)</span>" : "") + "</span></div>";
      });
      if (gifts.length) html += '<div class="bbx-tier-gift-note">While supplies last</div>';
      html += "</span>";
      html += '<span class="bbx-tier-prices"><span class="bbx-tier-now">' + (isRange ? '<span class="bbx-from">from </span>' : "") + MONEY(now) + "</span>";
      if (was > now) html += '<span class="bbx-tier-was">' + MONEY(was) + "</span>";
      html += "</span>";
      if (u === maxUnits && maxUnits > 1) html += '<span class="bbx-tier-ribbon">Best value</span>';
      html += "</label>";
    });
    html += "</div></div>";
    elSteps.innerHTML = html;

    elSteps.querySelectorAll("[data-bbx-tier]").forEach(function (lbl) {
      lbl.addEventListener("click", function () {
        setUnits(parseInt(lbl.getAttribute("data-bbx-tier"), 10));
        elSteps.querySelectorAll("[data-bbx-tier]").forEach(function (x) { x.classList.toggle("is-selected", x === lbl); });
        updateRail();
        updateNav();
      });
    });
  }

  /* ---------- step: customize ---------- */
  function renderCustomizeStep() {
    var html = '<div class="bbx-step">';
    html += '<h2 class="bbx-step-h bbx-serif">Customize your sets</h2>';
    html += '<p class="bbx-step-note">Pick a size and color for each set. They all start on ' + esc(STATE.sets[0] ? STATE.sets[0].size + " · " + STATE.sets[0].color : "the default") + " — change only what you want. <a href=\"#\" class=\"bbx-sizelink\" data-bbx-sizeopen>📏 Size guide</a></p>";
    html += '<div class="bbx-customize-bar"><div class="bbx-custbar-track"><span class="bbx-custbar-fill" data-bbx-custfill></span></div><span class="bbx-custbar-label" data-bbx-custlabel></span>';
    if (STATE.selectedUnits > 1) html += '<button type="button" class="bbx-applyall" data-bbx-applyall>⟳ Apply Set 1 to all</button>';
    html += "</div>";
    html += '<div class="bbx-setcards" data-bbx-setcards></div>';
    html += "</div>";
    elSteps.innerHTML = html;

    var wrap = elSteps.querySelector("[data-bbx-setcards]");
    for (var i = 0; i < STATE.selectedUnits; i++) wrap.appendChild(buildSetCard(i));

    var applyAll = elSteps.querySelector("[data-bbx-applyall]");
    if (applyAll) applyAll.addEventListener("click", function () {
      var s0 = STATE.sets[0];
      for (var j = 1; j < STATE.selectedUnits; j++) {
        var v = findVariant(s0.size, s0.color) || findVariant(s0.size, null);
        if (v) commitSet(j, s0.size, COLOR_IDX < 0 ? "" : s0.color, v);
      }
      var cards = elSteps.querySelector("[data-bbx-setcards]");
      cards.innerHTML = "";
      for (var k = 0; k < STATE.selectedUnits; k++) cards.appendChild(buildSetCard(k));
      updateCustomizeBar();
      updateRail();
    });
    updateCustomizeBar();
  }
  function updateCustomizeBar() {
    var ready = 0;
    for (var i = 0; i < STATE.selectedUnits; i++) if (STATE.sets[i] && STATE.sets[i].variantId) ready++;
    var fill = elSteps.querySelector("[data-bbx-custfill]");
    var label = elSteps.querySelector("[data-bbx-custlabel]");
    if (fill) fill.style.width = Math.round((ready / STATE.selectedUnits) * 100) + "%";
    if (label) label.textContent = ready + " of " + STATE.selectedUnits + " set" + (STATE.selectedUnits > 1 ? "s" : "") + " ready";
  }
  function buildSetCard(i) {
    var card = document.createElement("div");
    card.className = "bbx-setcard";
    var cur = STATE.sets[i] || defaultSet();
    var head = '<div class="bbx-setcard-head"><span class="bbx-setcard-num">' + (i + 1) + '</span><span class="bbx-setcard-title">Set ' + (i + 1) + "</span></div>";

    var body = "";
    if (COLOR_IDX >= 0) body += '<div class="bbx-setfield"><div class="bbx-setfield-label">Color</div><div class="bbx-colors" data-bbx-colors></div></div>';
    if (SIZE_IDX >= 0 && SIZES[0] !== "") body += '<div class="bbx-setfield"><div class="bbx-setfield-label">Size</div><div class="bbx-sizes" data-bbx-sizes></div></div>';
    card.innerHTML = head + body;

    function renderColors(size) {
      var wrap = card.querySelector("[data-bbx-colors]");
      if (!wrap) return;
      var list = colorsForSize(size).filter(function (c) { return c.variant.available; });
      wrap.innerHTML = "";
      list.forEach(function (c) {
        var v = c.variant, sale = salePctForSize(size, v.price);
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "bbx-color" + (c.color === STATE.sets[i].color ? " is-selected" : "") + (sale ? " bbx-color-sale" : "");
        btn.innerHTML = swatchHTML(c.color, v.img, sale ? "" : "") + (sale ? "" : "") + '<span class="bbx-swatch-name">' + esc(c.color || "Default") + "</span>";
        if (sale) btn.querySelector(".bbx-swatch").setAttribute("data-sale", "-" + sale + "%");
        btn.addEventListener("click", function () {
          commitSet(i, size, c.color, v);
          wrap.querySelectorAll(".bbx-color").forEach(function (x) { x.classList.remove("is-selected"); });
          btn.classList.add("is-selected");
          syncSel();
          updateRail();
        });
        wrap.appendChild(btn);
      });
    }
    function renderSizes() {
      var wrap = card.querySelector("[data-bbx-sizes]");
      if (!wrap) return;
      wrap.innerHTML = "";
      SIZES.forEach(function (s) {
        var avail = sizeAvailable(s);
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "bbx-size" + (s === STATE.sets[i].size ? " is-selected" : "") + (avail ? "" : " is-soldout");
        btn.textContent = s;
        if (!avail) btn.disabled = true;
        btn.addEventListener("click", function () {
          if (btn.disabled) return;
          // keep color if available in new size, else first available
          var keep = STATE.sets[i].color;
          var v = findVariant(s, keep) ;
          if (!v || !v.available) {
            var firstC = colorsForSize(s).filter(function (c) { return c.variant.available; })[0];
            v = firstC ? firstC.variant : findVariant(s, null);
            keep = firstC ? firstC.color : (v ? colorOf(v) : "");
          }
          if (!v) return;
          commitSet(i, s, COLOR_IDX < 0 ? "" : keep, v);
          wrap.querySelectorAll(".bbx-size").forEach(function (x) { x.classList.remove("is-selected"); });
          btn.classList.add("is-selected");
          renderColors(s);
          syncSel();
          updateRail();
        });
        wrap.appendChild(btn);
      });
    }
    function syncSel() {
      var ss = card.querySelector("[data-bbx-selsize]");
      var sc = card.querySelector("[data-bbx-selcolor]");
      if (ss) ss.textContent = STATE.sets[i].size;
      if (sc) sc.textContent = STATE.sets[i].color;
    }
    renderColors(cur.size);
    renderSizes();
    return card;
  }

  /* ---------- step: review ---------- */
  function renderReviewStep() {
    ensurePillowGiftDefault();
    var html = '<div class="bbx-step">';
    html += '<h2 class="bbx-step-h bbx-serif">Your free gifts &amp; finishing touches</h2>';
    html += '<p class="bbx-step-note">Gifts are already in your bundle — no code needed. Add anything else you\'d like, then review.</p>';

    // free gifts
    if (STATE.selectedUnits >= CFG.freeGiftMinUnits && CFG.mask && CFG.mask.available) {
      html += '<div class="bbx-giftrow"><span class="bbx-giftrow-ic">🎁</span><div class="bbx-giftrow-body"><div class="bbx-giftrow-name">Bamboo Sateen eye mask</div><div class="bbx-giftrow-meta">Auto-added to your bundle · while supplies last</div></div><span class="bbx-giftrow-free">FREE</span></div>';
    }
    if (STATE.selectedUnits >= CFG.pillowGiftMinUnits && STATE.pillowGift) {
      html += '<div class="bbx-giftrow" data-bbx-pillgift><span class="bbx-giftrow-ic">🎁</span><div class="bbx-giftrow-body"><div class="bbx-giftrow-name">Pillowcase set · <span data-bbx-pillgift-label>' + esc(STATE.pillowGift.size) + (STATE.pillowGift.color ? " · " + esc(STATE.pillowGift.color) : "") + '</span></div><div class="bbx-giftrow-meta">Auto-added · while supplies last · <a href="#" class="bbx-giftrow-change" data-bbx-pillgift-toggle>change</a></div><div class="bbx-giftrow-pickers" data-bbx-pillgift-pickers hidden></div></div><span class="bbx-giftrow-free">FREE</span></div>';
    }

    // already-added paid add-ons (shown above the builder, solid border)
    html += '<div class="bbx-added" data-bbx-added></div>';

    // add-ons
    html += '<p class="bbx-addons-h">Optional add-ons</p>';
    // extra pillowcase sets (multi)
    if (PILLOW.variants && PILLOW.variants.length) {
      var pSave = PILLOW.compareAt > PILLOW.price ? Math.round(((PILLOW.compareAt - PILLOW.price) / PILLOW.compareAt) * 100) : 0;
      html += '<div class="bbx-addon" data-bbx-addon-pillow><div class="bbx-addon-head">';
      html += swatchHTML(null, PILLOW.img, "bbx-addon-thumb");
      html += '<div class="bbx-addon-body"><div class="bbx-addon-name">Extra pillowcase sets</div><div class="bbx-addon-meta">' + (pSave ? '<s>' + MONEY2(PILLOW.compareAt) + "</s> " : "") + MONEY2(PILLOW.price) + " each" + (pSave ? ' · <b class="bbx-addon-save">' + pSave + "% OFF</b>" : "") + " · pick any color/size</div></div>";
      html += '<button type="button" class="bbx-addon-expand" data-bbx-pillexpand aria-expanded="false">+ Add</button></div>';
      html += '<div class="bbx-addon-builder" data-bbx-pillbuilder hidden>';
      html += '<div class="bbx-setfield"><div class="bbx-setfield-label">Size</div><div class="bbx-sizes" data-bbx-exsizes></div></div>';
      html += '<div class="bbx-setfield"><div class="bbx-setfield-label">Color</div><div class="bbx-colors" data-bbx-excolors></div></div>';
      html += '<div class="bbx-addon-add"><div class="bbx-qty"><button type="button" data-bbx-exminus>−</button><b data-bbx-exqty>1</b><button type="button" data-bbx-explus>+</button></div><button type="button" class="bbx-btn bbx-btn--primary bbx-addon-addbtn" data-bbx-exadd>Add to bundle</button></div>';
      html += "</div>";
      html += "</div>";
    }
    // extra eye mask
    if (CFG.mask && CFG.mask.available) {
      var mSave = CFG.mask.compareAt > CFG.mask.price ? Math.round(((CFG.mask.compareAt - CFG.mask.price) / CFG.mask.compareAt) * 100) : 0;
      html += '<div class="bbx-addon"><div class="bbx-addon-head">';
      html += swatchHTML(null, CFG.mask.img, "bbx-addon-thumb");
      html += '<div class="bbx-addon-body"><div class="bbx-addon-name">Extra bamboo eye mask</div><div class="bbx-addon-meta">' + (mSave ? "<s>" + MONEY2(CFG.mask.compareAt) + "</s> " : "") + MONEY2(CFG.mask.price) + " each" + (mSave ? ' · <b class="bbx-addon-save">' + mSave + "% OFF</b>" : "") + "</div></div>";
      html += '<div class="bbx-qty"><button type="button" data-bbx-mkminus>−</button><b data-bbx-mkqty>' + STATE.extraMaskQty + '</b><button type="button" data-bbx-mkplus>+</button></div></div></div>';
    }

    // your sets
    html += '<p class="bbx-addons-h">Your sets</p><div class="bbx-yoursets" data-bbx-yoursets></div>';
    html += "</div>";
    elSteps.innerHTML = html;

    renderYourSets();
    wireReviewEvents();
    updateRail();
  }
  function renderYourSets() {
    var wrap = elSteps.querySelector("[data-bbx-yoursets]");
    if (!wrap) return;
    var html = "";
    STATE.sets.forEach(function (s, i) {
      html += '<div class="bbx-yourset">' + swatchHTML(s.color, s.img, "bbx-yourset-sw") + '<div class="bbx-yourset-body"><div class="bbx-yourset-name">Set ' + (i + 1) + '</div><div class="bbx-yourset-sub">' + esc(s.size) + (s.color ? " · " + esc(s.color) : "") + '</div></div><button type="button" class="bbx-yourset-edit" data-bbx-edit="' + i + '">Edit</button></div>';
    });
    wrap.innerHTML = html;
    wrap.querySelectorAll("[data-bbx-edit]").forEach(function (b) {
      b.addEventListener("click", function () { goTo(1); });
    });
  }
  function wireReviewEvents() {
    // free pillow gift change
    var toggle = elSteps.querySelector("[data-bbx-pillgift-toggle]");
    if (toggle) toggle.addEventListener("click", function (e) {
      e.preventDefault();
      var pk = elSteps.querySelector("[data-bbx-pillgift-pickers]");
      if (!pk) return;
      var show = pk.hasAttribute("hidden");
      if (show) { pk.removeAttribute("hidden"); buildPillowGiftPickers(pk); } else pk.setAttribute("hidden", "");
    });
    // extra pillow builder
    var exp = elSteps.querySelector("[data-bbx-pillexpand]");
    if (exp) exp.addEventListener("click", function () {
      var b = elSteps.querySelector("[data-bbx-pillbuilder]");
      var open = b.hasAttribute("hidden");
      if (open) { b.removeAttribute("hidden"); exp.setAttribute("aria-expanded", "true"); exp.textContent = "Close"; buildExtraPickers(); } else { b.setAttribute("hidden", ""); exp.setAttribute("aria-expanded", "false"); exp.textContent = "+ Add"; }
    });
    var minus = elSteps.querySelector("[data-bbx-exminus]");
    var plus = elSteps.querySelector("[data-bbx-explus]");
    if (minus) minus.addEventListener("click", function () { stepExQty(-1); });
    if (plus) plus.addEventListener("click", function () { stepExQty(1); });
    var add = elSteps.querySelector("[data-bbx-exadd]");
    if (add) add.addEventListener("click", addExtraPillowLine);
    // extra mask
    var mkm = elSteps.querySelector("[data-bbx-mkminus]");
    var mkp = elSteps.querySelector("[data-bbx-mkplus]");
    if (mkm) mkm.addEventListener("click", function () { STATE.extraMaskQty = Math.max(0, STATE.extraMaskQty - 1); var q = elSteps.querySelector("[data-bbx-mkqty]"); if (q) q.textContent = STATE.extraMaskQty; updateRail(); });
    if (mkp) mkp.addEventListener("click", function () { STATE.extraMaskQty += 1; var q = elSteps.querySelector("[data-bbx-mkqty]"); if (q) q.textContent = STATE.extraMaskQty; updateRail(); });
    renderExtraLines();
  }
  function buildPillowGiftPickers(container) {
    var sizes = pillowSizes();
    var html = '<div class="bbx-setfield" style="margin-top:10px"><div class="bbx-setfield-label">Size</div><div class="bbx-sizes" data-bbx-pgsizes></div></div>';
    html += '<div class="bbx-setfield"><div class="bbx-setfield-label">Color</div><div class="bbx-colors" data-bbx-pgcolors></div></div>';
    container.innerHTML = html;
    var sizesWrap = container.querySelector("[data-bbx-pgsizes]");
    var cur = STATE.pillowGift || {};
    sizes.forEach(function (s) {
      var avail = pillowColorsForSize(s).some(function (c) { return c.variant.available; });
      var b = document.createElement("button");
      b.type = "button";
      b.className = "bbx-size" + (s === cur.size ? " is-selected" : "") + (avail ? "" : " is-soldout");
      b.textContent = s;
      if (!avail) b.disabled = true;
      b.addEventListener("click", function () { if (b.disabled) return; sizesWrap.querySelectorAll(".bbx-size").forEach(function (x) { x.classList.remove("is-selected"); }); b.classList.add("is-selected"); pgColors(container, s); });
      sizesWrap.appendChild(b);
    });
    pgColors(container, cur.size || sizes[0]);
  }
  function pgColors(container, size) {
    var wrap = container.querySelector("[data-bbx-pgcolors]");
    if (!wrap) return;
    var list = pillowColorsForSize(size).filter(function (c) { return c.variant.available; });
    var cur = STATE.pillowGift || {};
    wrap.innerHTML = "";
    list.forEach(function (c) {
      var v = c.variant;
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "bbx-color" + (cur.size === size && c.color === cur.color ? " is-selected" : "");
      btn.innerHTML = swatchHTML(c.color, v.img || PILLOW.img) + '<span class="bbx-swatch-name">' + esc(c.color) + "</span>";
      btn.addEventListener("click", function () {
        wrap.querySelectorAll(".bbx-color").forEach(function (x) { x.classList.remove("is-selected"); });
        btn.classList.add("is-selected");
        STATE.pillowGift = { variantId: v.id, size: v.option1, color: v.option2, price: v.price, img: v.img || PILLOW.img };
        var lbl = elSteps.querySelector("[data-bbx-pillgift-label]");
        if (lbl) lbl.textContent = v.option1 + (v.option2 ? " · " + v.option2 : "");
        updateRail();
      });
      wrap.appendChild(btn);
    });
  }
  var _exDraft = { size: null, color: null, qty: 1 };
  function buildExtraPickers() {
    var sizes = pillowSizes();
    _exDraft.size = sizes[0];
    var sizesWrap = elSteps.querySelector("[data-bbx-exsizes]");
    sizesWrap.innerHTML = "";
    sizes.forEach(function (s, idx) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "bbx-size" + (idx === 0 ? " is-selected" : "");
      b.textContent = s;
      b.addEventListener("click", function () { sizesWrap.querySelectorAll(".bbx-size").forEach(function (x) { x.classList.remove("is-selected"); }); b.classList.add("is-selected"); _exDraft.size = s; exColors(s); });
      sizesWrap.appendChild(b);
    });
    exColors(sizes[0]);
  }
  function exColors(size) {
    var wrap = elSteps.querySelector("[data-bbx-excolors]");
    if (!wrap) return;
    var list = pillowColorsForSize(size).filter(function (c) { return c.variant.available; });
    _exDraft.color = list[0] ? list[0].color : null;
    wrap.innerHTML = "";
    list.forEach(function (c, idx) {
      var v = c.variant;
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "bbx-color" + (idx === 0 ? " is-selected" : "");
      btn.innerHTML = swatchHTML(c.color, v.img || PILLOW.img) + '<span class="bbx-swatch-name">' + esc(c.color) + "</span>";
      btn.addEventListener("click", function () { wrap.querySelectorAll(".bbx-color").forEach(function (x) { x.classList.remove("is-selected"); }); btn.classList.add("is-selected"); _exDraft.color = c.color; });
      wrap.appendChild(btn);
    });
  }
  function stepExQty(delta) {
    _exDraft.qty = Math.max(1, _exDraft.qty + delta);
    var q = elSteps.querySelector("[data-bbx-exqty]");
    if (q) q.textContent = _exDraft.qty;
  }
  function addExtraPillowLine() {
    var v = pillowFind(_exDraft.size, _exDraft.color) || pillowFind(_exDraft.size, null);
    if (!v) return;
    var existing = STATE.extraPillows.filter(function (e) { return e.variant.id === v.id; })[0];
    if (existing) existing.qty += _exDraft.qty;
    else STATE.extraPillows.push({ variant: v, qty: _exDraft.qty });
    _exDraft.qty = 1;
    var q = elSteps.querySelector("[data-bbx-exqty]");
    if (q) q.textContent = 1;
    renderExtraLines();
    updateRail();
  }
  function renderExtraLines() {
    var wrap = elSteps.querySelector("[data-bbx-added]");
    if (!wrap) return;
    var html = "";
    STATE.extraPillows.forEach(function (e, idx) {
      var img = e.variant.img || PILLOW.img;
      var sub = esc(e.variant.title).split(" / ").join(" · ") + " × " + e.qty;
      html += '<div class="bbx-added-row">';
      html += '<span class="bbx-added-thumb"' + (img ? ' style="background-image:url(\'' + img + '\')"' : "") + ' aria-hidden="true"></span>';
      html += '<div class="bbx-added-body"><div class="bbx-added-name">Extra pillowcase set</div><div class="bbx-added-sub">' + sub + "</div></div>";
      html += '<span class="bbx-added-price">' + MONEY2(e.variant.price * e.qty) + "</span>";
      html += '<button type="button" class="bbx-addon-rm" data-bbx-exrm="' + idx + '" aria-label="Remove">&times;</button>';
      html += "</div>";
    });
    wrap.innerHTML = html;
    wrap.querySelectorAll("[data-bbx-exrm]").forEach(function (b) {
      b.addEventListener("click", function () { STATE.extraPillows.splice(parseInt(b.getAttribute("data-bbx-exrm"), 10), 1); renderExtraLines(); updateRail(); });
    });
  }

  /* ---------- step dispatch ---------- */
  function renderStep() {
    var st = STEPS[STATE.step];
    if (st.key === "bundle") renderBundleStep();
    else if (st.key === "customize") renderCustomizeStep();
    else renderReviewStep();
    renderProgress();
    updateNav();
    if (window.scrollY > root.offsetTop + 80) root.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  function updateNav() {
    elBack.hidden = STATE.step === 0;
    var isReview = STEPS[STATE.step].key === "review";
    elNext.textContent = isReview ? "Add bundle to cart →" : "Continue →";
    elNext.disabled = false;
  }
  function goTo(i) { if (i < 0 || i >= STEPS.length) return; STATE.step = i; renderStep(); }
  elBack.addEventListener("click", function () { goTo(STATE.step - 1); });
  elNext.addEventListener("click", function () {
    if (STEPS[STATE.step].key === "review") { addToCart(); return; }
    goTo(STATE.step + 1);
  });

  /* ---------- summary rail ---------- */
  function extrasTotalCents() {
    var t = 0;
    STATE.extraPillows.forEach(function (e) { t += e.variant.price * e.qty; });
    t += STATE.extraMaskQty * (CFG.mask ? CFG.mask.price : 0);
    return t;
  }
  function updateRail() {
    if (STATE.selectedUnits >= CFG.pillowGiftMinUnits) ensurePillowGiftDefault();
    var chosen = STATE.sets.slice(0, STATE.selectedUnits).filter(function (s) { return s && s.variantId; });
    if (elRailBody) elRailBody.classList.add("has-selection");
    if (elRailBadge) elRailBadge.textContent = STATE.selectedUnits + (STATE.selectedUnits > 1 ? " sets" : " set");
    var lastImg = chosen.length ? chosen[chosen.length - 1].img : null;
    if (lastImg && elRailImg) elRailImg.src = lastImg;

    var lis = "";
    for (var i = 0; i < STATE.selectedUnits; i++) {
      var s = STATE.sets[i];
      lis += '<li><span class="bbx-rl-num">' + (i + 1) + '.</span>' + swatchHTML(s.color, s.img) + esc(s.size) + (s.color ? " · " + esc(s.color) : "") + "</li>";
    }
    if (STATE.selectedUnits >= CFG.freeGiftMinUnits && CFG.mask && CFG.mask.available) lis += '<li class="bbx-rl-gift">🎁 Bamboo Sateen eye mask <span class="bbx-rl-free">FREE</span></li>';
    if (STATE.selectedUnits >= CFG.pillowGiftMinUnits && STATE.pillowGift) lis += '<li class="bbx-rl-gift">🎁 Pillowcase set · ' + esc(STATE.pillowGift.size) + ' <span class="bbx-rl-free">FREE</span></li>';
    STATE.extraPillows.forEach(function (e) { lis += '<li><span class="bbx-rl-num">+</span>' + esc(e.variant.title) + " × " + e.qty + "</li>"; });
    if (STATE.extraMaskQty > 0) lis += '<li><span class="bbx-rl-num">+</span>Eye mask × ' + STATE.extraMaskQty + "</li>";
    elRailList.innerHTML = lis;

    var pr = priceSets(chosen);
    var ex = extrasTotalCents();
    // Value of the free gifts — added to both list price and savings so the math reconciles.
    var giftCents = 0;
    if (STATE.selectedUnits >= CFG.freeGiftMinUnits && CFG.mask && CFG.mask.available) giftCents += giftValue(CFG.mask);
    if (STATE.selectedUnits >= CFG.pillowGiftMinUnits && STATE.pillowGift) giftCents += (STATE.pillowGift.price || giftValue(PILLOW));
    elRailPrices.hidden = false;
    elRailWas.textContent = MONEY2(pr.list + ex + giftCents);
    if (pr.discount > 0) { elRailSaveLine.hidden = false; elRailSave.textContent = "− " + MONEY2(pr.discount); } else elRailSaveLine.hidden = true;
    if (giftCents > 0 && elRailGiftLine) { elRailGiftLine.hidden = false; elRailGift.textContent = "− " + MONEY2(giftCents); } else if (elRailGiftLine) elRailGiftLine.hidden = true;
    elRailNow.textContent = MONEY2(pr.total + ex);
    elAddCart.disabled = false;
    if (elCheckout) elCheckout.disabled = false;
    elAddCartLabel.textContent = "Add to cart";
  }

  /* ---------- add to cart ---------- */
  var adding = false;
  function addToCart(goCheckout) {
    if (adding) return;
    adding = true;
    var busyBtn = goCheckout && elCheckout ? elCheckout : elAddCart;
    busyBtn.classList.add("is-adding");
    elNext.disabled = true;
    elAddCart.disabled = true;
    if (elCheckout) elCheckout.disabled = true;
    var items = [];
    STATE.sets.slice(0, STATE.selectedUnits).forEach(function (s) { items.push({ id: s.variantId, quantity: 1 }); });
    if (STATE.selectedUnits >= CFG.freeGiftMinUnits && CFG.mask && CFG.mask.available && CFG.mask.variantId) {
      items.push({ id: CFG.mask.variantId, quantity: 1, properties: { _osc_free_gift: "1", "Free gift": "With your bundle — while supplies last" } });
    }
    if (STATE.selectedUnits >= CFG.pillowGiftMinUnits && STATE.pillowGift && STATE.pillowGift.variantId) {
      items.push({ id: STATE.pillowGift.variantId, quantity: 1, properties: { _osc_free_gift: "1", "Free gift": "With your 6-pack — while supplies last" } });
    }
    STATE.extraPillows.forEach(function (e) { items.push({ id: e.variant.id, quantity: e.qty }); });
    if (STATE.extraMaskQty > 0 && CFG.mask && CFG.mask.variantId) items.push({ id: CFG.mask.variantId, quantity: STATE.extraMaskQty });

    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function () {
        // Stamp a hidden cart attribute so the order can be tagged (via Shopify
        // Flow) as coming from the guided bundle builder. Never block checkout
        // if this fails.
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ attributes: { _ordered_via: "bundle-builder" } }),
        }).catch(function () {});
      })
      .then(function () {
        adding = false;
        busyBtn.classList.remove("is-adding");
        if (goCheckout) { window.location.href = "/checkout"; return; }
        elAddCart.disabled = false;
        if (elCheckout) elCheckout.disabled = false;
        elNext.disabled = false;
        var hadCart = typeof getCartData === "function";
        if (hadCart) getCartData();
        if (typeof toggleSideCart === "function") toggleSideCart();
        else if (!hadCart) window.location.href = "/cart";
      })
      .catch(function () {
        adding = false;
        busyBtn.classList.remove("is-adding");
        elAddCart.disabled = false;
        if (elCheckout) elCheckout.disabled = false;
        elNext.disabled = false;
        alert("Sorry — something went wrong adding to cart. Please try again.");
      });
  }
  elAddCart.addEventListener("click", function () { addToCart(false); });
  if (elCheckout) elCheckout.addEventListener("click", function () { addToCart(true); });

  /* ---------- size guide modal ---------- */
  var modal = root.querySelector("[data-bbx-sizemodal]");
  function openModal() { if (modal) { modal.removeAttribute("hidden"); document.body.style.overflow = "hidden"; } }
  function closeModal() { if (modal) { modal.setAttribute("hidden", ""); document.body.style.overflow = ""; } }
  root.addEventListener("click", function (e) {
    if (e.target.closest("[data-bbx-sizeopen]")) { e.preventDefault(); openModal(); }
    if (e.target.closest("[data-bbx-sizeclose]")) closeModal();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeModal(); });

  /* ---------- boot ---------- */
  setUnits(STATE.selectedUnits);
  renderStep();
  updateRail();
})();
